import '.an{position:relative;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.i2{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.at{align-items:flex-start;}.ssr-plugin'
import '.d0{padding:2rem;}.ssr-plugin'
import '.e0{background:var(--palette-white);}.ssr-plugin'
import '.bb{overflow:hidden;}.ssr-plugin'
import '.bk{position:absolute;}.ssr-plugin'
import '.jp{top:50%;}.ssr-plugin'
import '.jq{right:1rem;}.ssr-plugin'
import '.jr{transform:translateY(-50%);}.ssr-plugin'
import '.js{width:120px;}.ssr-plugin'
import '.jt{height:120px;}.ssr-plugin'
import '.ju{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.j5{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jv{max-width:calc(100% - 140px);}.ssr-plugin'
import '.jw{font-size:4rem;}.ssr-plugin'
import '.dv{font-weight:700;}.ssr-plugin'
import '.jx{line-height:100%;}.ssr-plugin'
import '.h7{margin:0px;}.ssr-plugin'
import '.a1{color:var(--brand-secondary);}.ssr-plugin'
import '.a2{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="an l i2 d e ad at d0 e0 bb"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bk jp jq jr js jt ju d r ad"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="an j5 d e at s jv"
      >
        <div className="jw dv jx h7 a1 a2"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
